<template>
  <div class="ssoWaiting">
    <p class="oneTitle">Waiting for audit</p>
    <el-divider></el-divider>
    <div class="wait"><img
      class="tvuImg"
      src="@/assets/img/waiting.png"
      alt=""
      width="65"></div>
    <p class="twoTitle four">Great! Thanks for setting up. </p>
    <p class="twoTitle four">We will send you an email at
      <strong>{{contactEmail}}</strong> when your TVU services can sign in with SSO. </p>
    <div class="operate">
      <el-button
        class="confirmBtn cursor"
        @click="routerPush('/signInsso')">{{$t('lang.done')}}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Success',
  data () {
    return {
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      }
    }
  },
  computed: {
    contactEmail () {
      return this.$store.state.contactEmail
    }
  },
  created () {
    // this.downloadJSAtOnload();

  },
  mounted () {

  },
  methods: {
    routerPush (path) {
      ga('send', 'event', 'newUserService-ssoConfig-back', 'click')
      this.$store.commit('changeShowConfig', false)
      this.$router.push(path)
    }
  },
  beforeDestroy () {

  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('changeShowConfig', true)
    })
  }
}
</script>
